import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { WithDbMeta } from '../../../data/models/base.model';
import { Scenario } from '../../../data/models/scenario.model';
import { trimmedRequiredValidator } from '../../../shared/utils/form.validators';

export interface NewScenarioDialogData {
	scenarios: WithDbMeta<Scenario>[];
}

export interface NewScenarioDialogResult {
	name: string;
	copyFromId: string | null;
}

@Component({
	selector: 'dix-fmt-new-scenario-dialog',
	templateUrl: './new-scenario-dialog.component.html',
	imports: [ReactiveFormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatSelectModule],
})
export class NewScenarioDialogComponent {
	private readonly dialogRef = inject(MatDialogRef<NewScenarioDialogComponent, NewScenarioDialogResult>);
	readonly data = inject<NewScenarioDialogData>(MAT_DIALOG_DATA);

	readonly form = new FormGroup({
		name: new FormControl('', { nonNullable: true, validators: [trimmedRequiredValidator] }),
		copyFromId: new FormControl('', { nonNullable: true }),
	});

	create(): void {
		if (this.form.invalid) {
			this.form.markAllAsTouched();
			return;
		}
		const name = this.form.controls.name.value.trim() || 'New Scenario';
		const copyFromId = this.form.controls.copyFromId.value || null;
		this.dialogRef.close({ name, copyFromId });
	}

	cancel(): void {
		this.dialogRef.close();
	}
}
